// extracted by mini-css-extract-plugin
export default {"accordionRoot":"ExclusiveAccordionList_accordionRoot__ddGuE"};